/*=========================================================================================
  File Name: moduleCourseMutations.js
  Description: Course Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {

  ADD_ITEM(state, item) {
    
      state.CourseExams.unshift(item)
    },
    SET_CourseExam(state, courses) {
      state.CourseExams = courses
    },
    UPDATE_CourseExam(state, CourseExam) {
      const courseIndex = state.CourseExams.findIndex((p) => p.ID == CourseExam.ID)
      Object.assign(state.CourseExams[courseIndex], CourseExam)
  },
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.CourseExams.findIndex((p) => p.ID == itemId)
      state.CourseExams.splice(ItemIndex, 1)
  },
  SET_CourseModules(state, CourseExamModule) {
    
    state.CourseExamModules = CourseExamModule
  },
  ET_ExamType(state, ExamType) {
    
    state.ExamTypes = ExamType
  },

//   SET_CourseModule(state, courseModule) {
//     state.courseModules = courseModule;
//   },
//   ADD_Module(state, item) {
//     const ItemIndex = state.courseModules.findIndex((p) => p.Name == item.Name)
//     if(ItemIndex==-1)
//     {
//        if(item.OldName!=undefined)
//          this.REMOVE_Module(state,item.OldName)
//       state.courseModules.unshift(item);
//     }
//   },
//   Clear_ActiveModule(state)
//   {
//     state.courseModules=state.courseModules.map(function(val){val.IsActive=false; return val; })
//   },
//   REMOVE_Module(state, moduleName) 
//   {
//     const ItemIndex = state.courseModules.findIndex((p) => p.Name == moduleName)
//    if(ItemIndex!=-1)
//     state.courseModules.splice(ItemIndex, 1)
//   },
  
  
  }
  